import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor"


// OBTENER LA INFORMACION DE UN LOTE
export const trackingLot = async (PC) => {
    const response = PrivateInterceptor(`Produccion/tracking`, 'POST', PC);
    return response;
}

// CAMBIAR ESTADO DE UN LOTE
export const changeStateLot = async (PC) => {
    const response = PrivateInterceptor(`Produccion/PC/changeEstado`, 'POST', PC);
    return response;
}

export const changeFechasTintoreria = async (Fecha, Tipo, IdPartida) => {
    const response = PrivateInterceptor(`Produccion/Partida/FechasTintoreria`, 'POST', {Fecha, Tipo, IdPartida});
    return response;
}

export const getReProcesos = async (PC) =>{
    const response = PrivateInterceptor(`Produccion/ReProcesos/${PC}`, 'GET', )
    return response
}

export const getPartidas = async (PC) =>{
    const response = PrivateInterceptor(`Produccion/Partidas/${PC}`, 'GET', )
    return response
}

export const getEstadoQC = async (PC) =>{
    const response = PrivateInterceptor(`Produccion/EstadoQC/${PC}`, 'GET',)
    return response
}